import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Space,
  Select,
  Radio,
  Upload,
} from "antd";

import { FormOutlined, PlusOutlined } from "@ant-design/icons";

import { Server, Http } from "../../Http";
import queryString from "query-string";

import styles from "./ScanSave.module.less";

const { TextArea } = Input;
const { Option } = Select;

function ScanSave({ navigate, location }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);
  const [brands, setBrands] = useState([]);
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
  });
  const [thumbs, setThumbs] = useState([]);

  const [form] = Form.useForm();

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.result;
      }
      return file;
    });
    setThumbs(fileList);
  };

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const getBrandList = async (params) => {
    try {
      let para = queryString.stringify({
        pageNumber: params.brandPagination.current,
        pageSize: params.brandPagination.pageSize,
      });
      let parsed = await Http.get(`brand`, {
        searchParams: para,
      }).json();
      if (parsed.state === "ok") {
        setBrands([...brands, ...parsed.result.list]);
        setBrandPagination({
          current: parsed.result.pageNumber,
          pageSize: parsed.result.pageSize,
          total: parsed.result.totalRow,
        });
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
    }
  };

  const onFinish = async (values) => {
    setSubmit(true);
    let images = [];
    if (thumbs.length > 0) {
      thumbs.forEach((val) => {
        images.push(val.url);
      });
    }
    values.url = images.join(",");
    if (data) {
      values = { ...data, ...values };
    }
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`scan/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    getBrandList({ brandPagination });
    if (data) {
      let fileList = [];
      if (data.url) {
        data.url.split(",").forEach((value, key) => {
          fileList.push({
            uid: -(key + 1),
            name: "image.jpeg",
            status: "done",
            url: value,
          });
        });
      }
      setThumbs(fileList);
      form.setFieldsValue(data);
    }
  }, [data]);

  return (
    <div className={styles.ScanSave}>
      <div className={styles.header}>
        <FormOutlined style={{ fontSize: 16, color: "#1890ff" }} />
        <i>{data ? "舆情编辑" : "新增舆情"}</i>
      </div>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              name="brandId"
              label="品牌"
              rules={[{ required: true, message: "请选择品牌!" }]}
            >
              <Select
                showSearch
                placeholder="请选择品牌"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {brands.map((value) => (
                  <Option value={value.id} key={value.id}>
                    {value.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="word"
              label="搜索关键词"
              rules={[{ required: true, message: "请输入搜索关键词!" }]}
            >
              <Input placeholder="请输入搜索关键词" />
            </Form.Item>
            <Form.Item
              name="engine"
              label="搜索引擎"
              rules={[{ required: true, message: "请选择搜索引擎!" }]}
            >
              <Radio.Group>
                <Radio style={{ lineHeight: "32px" }} value={1}>
                  百度（PC）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={2}>
                  百度（手机）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={3}>
                  搜狗（PC）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={4}>
                  搜狗（手机）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={5}>
                  360（PC）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={6}>
                  360（手机）
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={7}>
                  神马
                </Radio>
                <Radio style={{ lineHeight: "32px" }} value={8}>
                  其他
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="type"
              label="类型"
              rules={[{ required: true, message: "请选择类型!" }]}
            >
              <Radio.Group>
                <Radio value={1}>相关下拉</Radio>
                <Radio value={2}>快照屏蔽</Radio>
                <Radio value={3}>负面删除</Radio>
                <Radio value={4}>评论删除</Radio>
                <Radio value={5}>其他</Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="str"
              label="链接/内容"
              rules={[
                {
                  required: true,
                  message: "请输入数据，一行一条记录！",
                },
              ]}
            >
              <TextArea placeholder="请输入数据，一行一条记录！" rows={3} />
            </Form.Item>
            <Form.Item name="url" label="图片">
              <Upload
                action={Server + "/scan/upload"}
                accept=".jpg,.jpeg,.png,.bmp,.gif"
                listType="picture-card"
                method="post"
                fileList={thumbs}
                onChange={handleChange}
                multiple
              >
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8, fontSize: 12 }}>添加图片</div>
                </div>
              </Upload>
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 4 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default ScanSave;
